import React from 'react';
import { SaveOutlined } from '@ant-design/icons';
import i18n from '~/i18n';
import { Col, Row, Typography } from 'antd';
import './style.css';
import DeleteButton from './components/DeleteButton';
import TransparentOverlay from '../../../components/TransparentOverlay';

const { Text } = Typography;

const BottomBar = ({
  onSave,
  disabled,
}: {
  onSave: () => void;
  disabled: boolean;
}) => {
  return (
    <Row className="cart-bottom-bar-row">
      <TransparentOverlay show={disabled} />
      <Col span={12}>
        <DeleteButton />
      </Col>
      <Col span={12} className="cart-bottom-bar-button" onClick={onSave}>
        <SaveOutlined />
        <Text>{i18n.t('cart_save')}</Text>
      </Col>
    </Row>
  );
};

export default BottomBar;
